import styled from 'styled-components'
import {
  mediaMax,
  calculateResponsiveSize,
  themeColor
} from '@dboxdev/ui-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  textarea {
    width: 100%;
    height: ${calculateResponsiveSize(80)};
    padding: ${calculateResponsiveSize(10)};
    font-size: ${calculateResponsiveSize(18)};
    color: ${themeColor('textColor')};
    font-weight: 300;
    border-radius: 10px;
    border: 1px solid ${themeColor('accentColor')};
  }
  ${mediaMax('mobile')} {
    textarea {
      height: ${calculateResponsiveSize(30)};
      padding: ${calculateResponsiveSize(6)} ${calculateResponsiveSize(10)};
      font-size: ${calculateResponsiveSize(12)};
      border-radius: 4px;
    }
  }
`

export const Title = styled.div`
  &:first-child {
    margin: 0 0 ${calculateResponsiveSize(8)} 0;
  }
  &:last-child {
    margin: ${calculateResponsiveSize(8)} 0 0 0;
  }
  &.error {
    color: red;
  }
  ${mediaMax('mobile')} {
    &:first-child {
      margin: 0 0 ${calculateResponsiveSize(3)} 0;
    }
    &:last-child {
      margin: ${calculateResponsiveSize(3)} 0 0 0;
    }
  }
`

export const InputField = styled.input`
  width: 100%;
  height: ${calculateResponsiveSize(36)};
  padding: 0;
  font-size: ${calculateResponsiveSize(18)};
  color: ${themeColor('textColor')};
  line-height: 1;
  font-weight: 300;
  border-radius: 0;
  border: 0;
  border-bottom: 1px solid ${themeColor('accentColor')};
  background: none;
  outline: none;
  &.error {
    border-color: red;
  }
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0 1000px ${themeColor('backgroundColor')}inset;
    -webkit-text-fill-color: ${themeColor('textColor')};
    transition: background-color 9999s ease-in-out 0s;
  }
  ${mediaMax('mobile')} {
    height: ${calculateResponsiveSize(30)};
    font-size: ${calculateResponsiveSize(12)};
  }
`
